import React, { useState } from "react";
import { useDeletePhotoMutation, useSavePhotoMutation } from '../../store';
import Button from "../shared/Button";
import ImageUploader from "../shared/ImageUploader";

export default function PhotoEdit({ photo, labels }) {
    const [title, setTitle] = useState(photo.title);
    const [src, setSrc] = useState(photo.src)

    const [savePhoto] = useSavePhotoMutation();
    const [deletePhoto] = useDeletePhotoMutation();

    const handleSave = function () {

        const photoToSave = {
            ...photo,
            title: title,
            src: src
        };

        if (photoToSave.id === 0) {
            handleCancel();
        }

        savePhoto(photoToSave)
        window.history.back();
    }

    const handleCancel = function () {
        setTitle(photo.title);
        setSrc(photo.src);
        window.history.back();
    }

    const handleDelete = function () {
        deletePhoto(photo);
        window.history.back();
    }

    return (
        <div className="gallery-photo text-center" >
            <div>
                <ImageUploader model={src} onChange={(e) => setSrc(e)}></ImageUploader>
            </div>
            <div>
                <textarea value={title} onChange={(e) => setTitle(e.target.value)}></textarea>
            </div>
            <div className="row">
                <Button eventHandler={handleSave}>{labels.saveButton}</Button>
                <Button eventHandler={handleCancel}>{labels.cancelButton}</Button>
                <Button eventHandler={handleDelete}>{labels.deleteButton}</Button>
            </div>
        </div>
    )
}